import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.search";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.replace";
// const ykzApp = window.ykzApp,
//     YCF_Plugin = window.YCF_Plugin,
//     $ = window.$;
import { buryingPoint } from "@/util/buryingPoint";
import { ex_getYCFLocInfo } from "../util/location";
import { toast, showLoading, hideLoading, getUrlQuery } from "@ykz/ykz-util/base";
import { isYkzMiniprogram, isYkzAlipayMiniprogram } from "@ykz/ykz-util/platform";
import databus, { Origins } from "@ykz/ykz-http/core";
export default {
  name: "city",
  props: {
    isShowIcon: {
      default: false
    },
    buttonHeight: {
      default: null
    },
    filterCityNumber: {
      default: 4
    },
    filterDistrictNumber: {
      default: 5
    },
    noPrecise: {
      //不需要精准定位
      default: false
    },
    needDistrict: {
      //首次进去是否展示区
      default: false
    },
    localStorageName: {
      //本地位置信息存储位置
      default: "shopping_mall_city"
    },
    defaultData: {
      //默认信息
      default: null
    }
  },
  data: function data() {
    return {
      cityKeyWords: "",
      // 搜索关键字
      placeholder: "广州/天河区",
      showCityMask: false,
      results: [],
      // 搜索结果

      isMini: isYkzMiniprogram(),
      //是否在微信小程序打开页面
      isAlipayMini: isYkzAlipayMiniprogram(),
      currentCity: {
        //当前选中城市
        cityName: "",
        cityCode: "",
        provinceCode: "",
        provinceName: "",
        districtName: "",
        districtCode: "",
        districtList: "",
        showDialog: 0,
        showDialogContent: 0,
        longitude: "",
        latitude: ""
      },
      nowEditCity: {
        //当前编辑城市
        cityName: "",
        cityCode: "",
        provinceName: "",
        provinceCode: "",
        districtName: "",
        districtCode: "",
        districtList: "",
        showDialog: 0,
        showDialogContent: 0,
        longitude: "",
        latitude: ""
      },
      currentProvince: {
        //当前选中的省市
        provinceCode: "",
        provinceName: "",
        cityList: []
      },
      nowEditProvince: {
        //当前编辑的省市
        provinceCode: "",
        provinceName: "",
        cityList: []
      },
      localCity: {
        //用户所在位置的定位
        districtName: "",
        provinceName: "",
        cityName: "",
        longitude: "",
        latitude: ""
      },
      winHeight: $(window).height(),
      isInApp: false,
      provinceList: [],
      //省份列表数据
      hotCityList: [],
      //热门城市
      user: {},
      //用户信息

      dialogHeight: 0,
      districtBox: {
        show: true,
        height: 0
      },
      entryTimes: 0
    };
  },
  filters: {
    _showCurrentCity: function _showCurrentCity(value) {
      return value.replace("市", "");
    }
  },
  mounted: function mounted() {
    this.initPage();
  },
  methods: {
    // .................................搜索Start....................................
    cleanInput: function cleanInput() {
      this.cityKeyWords = "";
      this.results = [];
      this.showCityMask = false;
    },
    handleSelectCity: function handleSelectCity(item) {
      var districtCode = item.districtCode,
        districtName = item.districtName,
        provinceName = item.provinceName,
        provinceCode = item.provinceCode,
        cityName = item.cityName,
        cityCode = item.cityCode,
        latitude = item.latitude,
        longitude = item.longitude;

      // 当前编辑城市
      this.nowEditCity.cityCode = cityCode;
      this.nowEditCity.cityName = cityName;
      this.nowEditCity.provinceName = provinceName;
      this.nowEditCity.provinceCode = provinceCode;
      this.nowEditCity.latitude = latitude;
      this.nowEditCity.longitude = longitude;
      this.nowEditCity.districtCode = districtCode;
      this.nowEditCity.districtName = districtName;
      if (districtCode && districtName) {
        // 选中区
        this.selectDistrict({
          districtCode: districtCode,
          districtName: districtName
        });

        // 统计处理,为了统一字段名
        this.fetchTJInfo({
          cityName: districtName,
          cityCode: districtCode
        }, "city_search");
      } else {
        // 选中市
        this.selectCity({
          cityName: cityName,
          cityCode: cityCode
        }, "city_search");
      }
      this.showCityMask = false;
      this.cityKeyWords = "";
    },
    handleInput: function handleInput() {
      if (!this.cityKeyWords.replace(/(^\s*)|(\s*$)/g, "")) {
        this.results = [];
        this.showCityMask = false;
        return;
      }
      showLoading({
        cover: true,
        opacity: 0
      });
      this.results = this.getSearchResults(this.cityKeyWords, this.provinceList);
      hideLoading();
      this.showCityMask = true;
    },
    getSearchResults: function getSearchResults(cityKeyWords, list) {
      var results = [];
      var cityList = [];

      //   合并省市区数
      list.forEach(function (item) {
        if (item.provinceCode != "100") {
          if (item.cityList && item.cityList.length) {
            item.cityList.forEach(function (v) {
              if (v.districtList && v.districtList.length) {
                v.districtList.forEach(function (i) {
                  var newCity = {
                    provinceCode: item.provinceCode,
                    // 省code
                    provinceName: item.provinceName,
                    // 省份名称
                    cityCode: v.cityCode,
                    // 市code
                    cityName: v.cityName,
                    // 市名称
                    districtCode: i.districtCode,
                    // 区code
                    districtName: i.districtName,
                    // 区名称
                    longitude: v.longitude,
                    // 经度
                    latitude: v.latitude // 纬度
                  };

                  cityList.push(newCity);
                });
              }
            });
          }
        }
      });

      // 匹配关键字
      cityList.forEach(function (item) {
        if (item.cityName.includes(cityKeyWords) || item.districtName.includes(cityKeyWords)) {
          if (item.cityName.includes(cityKeyWords)) {
            if (!results.length) {
              item.searchName = item.cityName;
              item.districtName = "";
              item.districtCode = "";
              results.push(item);
            } else {
              if (results.length > 1 && results[results.length - 1].searchName != item.cityName) {
                // 只保留一条市级搜索
                item.searchName = item.cityName;
                item.districtName = "";
                item.districtCode = "";
                results.push(item);
              }
            }
          }
          if (!item.cityName.includes(cityKeyWords) && item.districtName.includes(cityKeyWords)) {
            item.searchName = "".concat(item.districtName, "\uFF0C").concat(item.cityName);
            // 关键字匹配
            results.push(item);
          }
        }
      });
      // console.log(cityList, "<---cityList ");
      // console.log(results, "<---results 地址搜索结果");

      return results;
    },
    // .................................搜索End....................................
    fetchTJInfo: function fetchTJInfo(cityData, type) {
      if (cityData) {
        var cityName = cityData.cityName,
          cityCode = cityData.cityCode;
        var eventData = {
          city_search: "切换城市_搜索城市",
          city_hot: "切换城市_热门",
          city_choose: "切换城市_城市选择",
          // 通过省份选择城市
          city_common: "切换城市_常用",
          // 用户点击常用城市
          city_county: "切换城市_切换县城"
        };
        var tjdata = {
          label: eventData[type],
          description: "".concat(this.nowEditCity.provinceName, "-").concat(cityName)
        };
        YCF_Plugin.anchorPoint(tjdata.label, type, tjdata.description);
      } else {
        // console.log(this.currentCity, "this.currentCity");
        YCF_Plugin.anchorPoint("切换城市", "switch_cities", "".concat(this.currentCity.provinceName, "-").concat(this.currentCity.cityName, "-").concat(this.currentCity.districtName));
      }
    },
    /// for test only
    testCurLocation: function testCurLocation() {
      console.log("testCurLocation suck suck suck");
      ex_getYCFLocInfo().then(function (res) {
        console.log(res);
      });
      console.log("testCurLocation suck suck suck after");
    },
    //处理页面返回
    initPage: function initPage() {
      var that = this;
      // 有默认数据更新历史数据
      if (that.defaultData && that.defaultData.cityName && that.defaultData.provinceName) {
        // window.localStorage.setItem(that.localStorageName, JSON.stringify(that.defaultData));

        that.setPositionToLocalStorage(that.defaultData);
      }
      that.getUserData();
      that.winHeight = $(window).height();
      // that.submitData(1);
    },

    //获取用户信息数据
    getUserData: function getUserData() {
      var that = this;
      showLoading({
        cover: true,
        opacity: 0
      });
      databus({
        url: "/apiv2/marketing/getPromoterStatus",
        data: {
          // userId: window.userId,
          source: that.isInApp ? 1 : 0,
          fxbInviteCode: getUrlParams("fxbInviteCode") || ""
        },
        success: function success(data) {
          that.$emit("getuserdata", data);
          if (data.code == 1000 && data.bcode == 100) {
            if (data.content.location && data.content.location.cityCode) {
              data.content.cityCode = data.content.location.cityCode;
              data.content.cityName = data.content.location.city;
              data.content.provinceCode = data.content.location.provinceCode;
              data.content.provinceName = data.content.location.province;
            }
            that.user = data.content;
          }
          that.initUserCity();
        },
        error: function error() {
          that.$emit("getuserdata", null);
          that.initUserCity();
        },
        complete: function complete() {
          hideLoading();
        }
      });
    },
    //初始化用户城市
    initUserCity: function () {
      var _initUserCity = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, hasSetCurrentCity, setCityData, urlCityName, provinceList, res, results, _results, storedCity;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setCityData = function _setCityData(cityData) {
                var cityCode = cityData.cityCode,
                  cityName = cityData.cityName,
                  districtCode = cityData.districtCode,
                  provinceCode = cityData.provinceCode,
                  provinceName = cityData.provinceName;
                window.localStorage.setItem(that.localStorageName, JSON.stringify({
                  cityCode: cityCode,
                  cityName: cityName,
                  districtCode: districtCode,
                  provinceCode: provinceCode,
                  provinceName: provinceName
                }));
              };
              that = this;
              hasSetCurrentCity = false;
              showLoading({
                cover: true,
                opacity: 0
              });
              urlCityName = getUrlQuery("cityName") ? decodeURIComponent(getUrlQuery("cityName")) : null;
              if (!urlCityName) {
                _context.next = 25;
                break;
              }
              provinceList = window.localStorage.getItem("provinceList");
              if (provinceList) {
                _context.next = 22;
                break;
              }
              _context.prev = 8;
              _context.next = 11;
              return this.getCityList();
            case 11:
              res = _context.sent;
              window.localStorage.setItem("provinceList", JSON.stringify(res));
              results = this.getSearchResults(urlCityName, res);
              if (results.length === 1) {
                setCityData(results[0]);
              }
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](8);
              console.error("Error getting city list:", _context.t0);
            case 20:
              _context.next = 25;
              break;
            case 22:
              // console.log(this.currentCity, "<---this.currentCity");

              //  this.localGetprovinceList();
              this.provinceList = JSON.parse(window.localStorage.getItem("provinceList")) || [];
              _results = this.getSearchResults(urlCityName, this.provinceList);
              if (_results.length === 1) {
                setCityData(_results[0]);
              }
            case 25:
              storedCity = window.localStorage.getItem(that.localStorageName); // console.log(storedCity, "<---storedCity");
              if (storedCity) {
                that.setDefaultCity(that.currentCity, JSON.parse(storedCity));
                hasSetCurrentCity = true;
              }
              ex_getYCFLocInfo().then(function (res) {
                // console.log(res, "<---ex_getYCFLocInfo");

                var locationData = {
                  longitude: res.longitude,
                  latitude: res.latitude,
                  provinceName: res.province,
                  cityName: res.city,
                  districtName: res.district
                };

                // res.authorization = true使用最新的定位更新当前城市
                if (!hasSetCurrentCity || res.authorization) {
                  // console.log(that.localCity, "<---that.localCity-then");
                  that.setCity(that.localCity, locationData);
                  that.setCity(that.currentCity, locationData);
                }
              }).catch(function (res) {}).finally(function () {
                // console.log(that.localCity, "<---that.localCity-finally");
                var defaultCoords = {
                  longitude: "104.114129",
                  latitude: "37.550339"
                };
                if (!that.localCity.provinceName || !that.localCity.cityName || that.localCity.longitude == defaultCoords.longitude && that.localCity.latitude == defaultCoords.latitude) {
                  that.setDefaultCity(that.localCity, that.user);
                }
                if (!hasSetCurrentCity) {
                  var currentCityData = $.extend(JSON.parse(JSON.stringify(that.localCity)), that.needDistrict ? {} : {
                    districtName: ""
                  });
                  that.setDefaultCity(that.currentCity, currentCityData);
                }
                that.getHotCityList();
                that.submitData(1);
              });

              // console.log(this.currentCity, "<---初始化currentCity");
              // console.log(this.nowEditCity, "<---初始化nowEditCity");
              // console.log(this.nowEditProvince, "<---初始化nowEditProvince");
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[8, 17]]);
      }));
      function initUserCity() {
        return _initUserCity.apply(this, arguments);
      }
      return initUserCity;
    }(),
    setPositionToLocalStorage: function setPositionToLocalStorage(location) {
      localStorage.setItem(this.localStorageName, JSON.stringify({
        provinceName: location.provinceName || location.province,
        cityName: location.cityName || location.city,
        districtName: location.districtName || location.district,
        cityCode: location.cityCode || "",
        districtCode: location.districtCode || "",
        provinceCode: location.provinceCode || ""
      }));
    },
    resetSearch: function resetSearch() {
      this.cityKeyWords = "";
      this.results = [];
      this.showCityMask = false;
    },
    showCityDialog: function showCityDialog() {
      var _this = this;
      var list = window.localStorage.getItem("provinceList") || [];
      this.resetSearch();
      if (list && list.length === 0) {
        this.getCityList().then(function (res) {
          window.localStorage.setItem("provinceList", JSON.stringify(res));
          _this.provinceList = res;
          _this.setProvinceInfo();
        });
      } else {
        this.localGetprovinceList();
      }
      this.entryTimes++;
    },
    localGetprovinceList: function localGetprovinceList() {
      var that = this;
      that.provinceList = JSON.parse(window.localStorage.getItem("provinceList")) || [];
      that.setProvinceInfo();
    },
    /**
     * 显示/隐藏 地区选择页面
     */
    toggleShowDialog: function toggleShowDialog() {
      var that = this;
      if (that.currentCity.showDialog == 0) {
        $("#mescroll").css("overflow-y", "hidden");
        buryingPoint("SY-DJDLWZ", "点击地理位置", "", "");
        that.currentCity.showDialog = 1;
        that.nowEditCity = JSON.parse(JSON.stringify(that.currentCity));
        that.setNowDistrict();
        that.$nextTick(function () {
          if (this.entryTimes === 1) {
            this.$nextTick(function () {
              if ($("#componentCityDislog").offset()) {
                this.dialogHeight = $(window).height() - $("#componentCityDislog").offset().top;
              }
            });
          }
          that.setNowEditProvince();
        });
        if (that.currentCity.showDialog && that.provinceList.length <= 0) {
          toast("暂无城市数据，请刷新页面重试");
        }
        that.$nextTick(function () {
          that.cityScrollIntoView();
          setTimeout(function () {
            that.currentCity.showDialogContent = 1;
            that.nowEditCity.showDialogContent = 1;
            that.showDistrict();
            that.$emit("dialogshow", true);
            that.fetchTJInfo(null, "switch_cities");
          }, 100);
        });
      } else {
        $("#mescroll").css("overflow-y", "scroll");
        //切换隐藏
        that.$nextTick(function () {
          that.cityScrollIntoView();
          that.currentCity.showDialogContent = 0;
          that.nowEditCity = JSON.parse(JSON.stringify(that.currentCity));
          setTimeout(function () {
            that.currentCity.showDialog = 0;
            that.nowEditCity.showDialog = 0;
            that.setNowEditProvince();
            that.getHotCityList();
            that.showDistrict();
            that.$emit("dialogshow", false);
          }, 200);
        });
      }
    },
    setNowDistrict: function setNowDistrict() {
      this.nowEditCity.districtList = this.findDistrictListByCity(this.nowEditCity.cityName);
    },
    setNowEditProvince: function setNowEditProvince() {
      var historyList = JSON.parse(window.localStorage.getItem(this.localStorageName + "_history")) || [];
      this.nowEditProvince = JSON.parse(JSON.stringify(this.currentProvince));
      if (historyList.length > 0 || !this.nowEditProvince.provinceCode || this.currentCity.cityName.indexOf(this.provinceList[0].cityList[0].cityName) >= 0) {
        this.nowEditProvince = JSON.parse(JSON.stringify(this.provinceList[0]));
      }
      if (!this.nowEditCity.cityCode) {
        this.nowEditCity.cityCode = 100;
      }
    },
    //定位到选中的城市
    cityScrollIntoView: function cityScrollIntoView() {
      var boxHeight = $("#cityBox").height();
      $("#cityBox").scrollTop(1);
      $("#provinceBox").scrollTop(1);
      if (!window.localStorage.getItem(this.localStorageName)) {
        if ($("#province_" + this.nowEditProvince.provinceCode).position()) {
          $("#provinceBox").scrollTop($("#province_" + this.nowEditProvince.provinceCode).position().top - boxHeight * 0.5);
        }
        if ($("#city_" + this.nowEditCity.cityCode).position()) {
          $("#cityBox").scrollTop($("#city_" + this.nowEditCity.cityCode).position().top - boxHeight * 0.5);
        }
      }
    },
    //设置默认城市
    setDefaultCity: function setDefaultCity(target, data) {
      if (data.cityName && data.provinceName) {
        this.setCity(target, data);
      } else {
        this.setCity(target, {
          longitude: "113.270793",
          latitude: "23.135308",
          provinceCode: "440000",
          cityCode: "440100",
          provinceName: "广东省",
          cityName: "广州市",
          districtName: "越秀区"
        });
      }
    },
    //设置城市值
    setCity: function setCity(target, data) {
      target.longitude = data.longitude || "";
      target.latitude = data.latitude || "";
      target.provinceName = data.provinceName || "广东省";
      target.cityName = data.cityName || "广州市";
      target.provinceCode = data.provinceCode || "";
      target.cityCode = data.cityCode || "440100";
      target.districtName = data.districtName || "";
      target.districtCode = data.districtCode || "";
    },
    provinseBoxScroll: function provinseBoxScroll(e) {
      // console.log("provinseBoxScroll");
      if (e) {
        e.preventDefault();
      }
      if ($("#provinceBox").scrollTop() <= 0) {
        $("#provinceBox").scrollTop(1);
      }
    },
    //获取热门城市列表
    getHotCityList: function getHotCityList() {
      var that = this;
      databus({
        url: "/appapi/promotionmall/getHotCityList",
        noLongLatitude: true,
        data: {
          city: that.currentCity.cityName || ""
        },
        success: function success(data) {
          if (data.code == 1000 && data.bcode == 100) {
            that.hotCityList = data.content.hotCityList || [];
          }
        }
      });
    },
    //获取城市列表
    getCityList: function getCityList() {
      return new Promise(function (resolve, reject) {
        showLoading({
          cover: true
        });
        databus({
          url: "apiv2/marketing/cityProvince",
          data: {},
          success: function success(data) {
            if (data.code == 1000 && data.bcode == 100) {
              resolve(data.content.dataList || []);
            }
            hideLoading();
          },
          error: function error() {
            hideLoading();
          }
        });
      });
    },
    setProvinceInfo: function setProvinceInfo() {
      var that = this;
      that.toggleShowDialog();
      if (this.nowEditCity.cityCode === "") {
        this.findCityCode();
      }
      if (that.provinceList.length > 0) {
        that.searchCityCode(that.provinceList);
      }
      that.extendProvinceList();
    },
    findCityCode: function findCityCode() {
      var list = this.findProvinceByCity(this.currentCity.cityName).cityList;
      for (var i = 0; i < list.length; i++) {
        if (this.currentCity.cityName === list[i].cityName) {
          this.nowEditCity.cityCode = list[i].cityCode;
        }
      }
    },
    // 删除url上的cityName参数
    removeCityNameParameter: function removeCityNameParameter() {
      // 获取当前URL
      var url = new URL(window.location.href);

      // 获取URL参数
      var params = new URLSearchParams(url.search);

      // 删除cityName参数
      params.delete("cityName");

      // 更新URL，不重新加载页面
      window.history.replaceState({}, document.title, url.pathname + "?" + params.toString());
    },
    //拓展省份列表
    extendProvinceList: function extendProvinceList() {
      var that = this;
      var province = null,
        city = null,
        district = null;
      var localCityItem = {
        cityCode: "100",
        provinceCode: "100",
        cityName: that.localCity.cityName,
        provinceName: that.localCity.provinceName
      };
      var historyItem = {
        provinceCode: "100",
        provinceName: "热门城市",
        cityList: []
      };
      if (that.localCity.cityName && that.localCity.provinceName) {
        localCityItem.provinceName = that.localCity.provinceName;
        localCityItem.cityName = that.localCity.cityName;
      } else {
        that.setDefaultCity(localCityItem, that.user);
        that.setDefaultCity(localCityItem, that.user);
      }
      province = that.provinceList.find(function (item) {
        return that.theSameProvince(item.provinceName, localCityItem.provinceName);
      });
      if (province) {
        city = province.cityList.find(function (item) {
          return that.theSameCity(item.cityName, localCityItem.cityName);
        });
        localCityItem = $.extend(localCityItem, {
          provinceCode: province.provinceCode
        });
      }
      if (city) {
        district = city.districtList.find(function (item) {
          return that.theSameDistrict(item.districtName, localCityItem.districtName);
        });
        localCityItem = $.extend(localCityItem, {
          cityCode: city.cityCode
        });
      }
      if (district) {
        localCityItem = $.extend(localCityItem, {
          districtCode: district.districtCode
        });
      }
      // for (i = 0; i < that.provinceList.length; i++) {
      //     if (that.provinceList[i].provinceName.indexOf(localCityItem.provinceName) >= 0) {
      //         var cityList = that.provinceList[i].cityList;
      //         for (j = 0; j < cityList.length; j++) {
      //             if (cityList[j].cityName == localCityItem.cityName) {
      //                 localCityItem.cityCode = cityList[j].cityCode;
      //             } else if (!localCityItem.cityCode && cityList[j].cityName.indexOf(localCityItem.cityName) >= 0) {
      //                 localCityItem.cityCode = cityList[j].cityCode;
      //             }
      //             for (z = 0; z < cityList.length; z++) {
      //                 if (cityList[j].cityName == localCityItem.cityName) {
      //                     localCityItem.cityCode = cityList[j].cityCode;
      //                 } else if (!localCityItem.cityCode && cityList[j].cityName.indexOf(localCityItem.cityName) >= 0) {
      //                     localCityItem.cityCode = cityList[j].cityCode;
      //                 }

      //             }
      //         }
      //     }
      // }
      historyItem.cityList.push(localCityItem);
      that.provinceList.unshift(historyItem);
      that.extendCityList();
    },
    // 拓展历史城市列表
    extendCityList: function extendCityList() {
      var that = this;
      var historyList = JSON.parse(window.localStorage.getItem(that.localStorageName + "_history")) || [];
      if (historyList.length > 0) {
        for (var i = 0; i < historyList.length; i++) {
          if (historyList[i].cityCode == that.provinceList[0].cityList[0].cityCode || that.theSameCity(historyList[i].cityName, that.provinceList[0].cityList[0].cityName)) {
            historyList.splice(i, 1);
          }
        }
        that.provinceList[0].cityList = that.provinceList[0].cityList.slice(0, 1);
        that.provinceList[0].cityList = that.provinceList[0].cityList.concat(historyList).slice(0, 7);
      }
    },
    //根据城市名获取cityCode和省份
    searchCityCode: function searchCityCode(provinceList) {
      var that = this;
      var province = null,
        city = null,
        district = null;
      province = provinceList.find(function (item) {
        return that.theSameProvince(item.provinceName, that.currentCity.provinceName);
      });
      if (province) {
        city = province.cityList.find(function (item) {
          return that.theSameCity(item.cityName, that.currentCity.cityName);
        });
        that.currentCity = $.extend(that.currentCity, {
          provinceName: province.provinceName,
          provinceCode: province.provinceCode,
          cityList: province.cityList
        });
        that.currentProvince = $.extend(that.currentProvince, {
          provinceName: province.provinceName,
          provinceCode: province.provinceCode,
          cityList: province.cityList
        });
      }
      if (city) {
        district = city.districtList.find(function (item) {
          return that.theSameDistrict(item.districtName, that.currentCity.districtName);
        });
        that.currentCity = $.extend(that.currentCity, {
          cityName: city.cityName,
          cityCode: city.cityCode
        });
      }
      if (district) {
        that.currentCity = $.extend(that.currentCity, {
          districtCode: district.districtCode
        });
      }
      // for (var i = 0; i < provinceList.length; i++) {
      //     if (provinceList[i].provinceName && this.theSameProvince(provinceList[i].provinceName, provinceName)) {
      //         var cityList = provinceList[i].cityList;
      //         this.currentCity.provinceName = provinceList[i].provinceName;
      //         this.currentCity.provinceCode = provinceList[i].provinceCode;
      //         this.currentProvince.provinceName = provinceList[i].provinceName;
      //         this.currentProvince.provinceCode = provinceList[i].provinceCode;
      //         this.currentProvince.cityList = provinceList[i].cityList;
      //         for (var j = 0; j < cityList.length; j++) {
      //             if (cityList[j].cityName && this.theSameCity(cityList[j].cityName, cityName)) {
      //                 this.currentCity.cityName = cityList[j].cityName;
      //                 this.currentCity.cityCode = cityList[j].cityCode;
      //             } else if (!this.currentCity.cityCode && cityList[j].cityName && that.theSameCity(cityList[j].cityName, cityName)) {
      //                 this.currentCity.cityName = cityList[j].cityName;
      //                 this.currentCity.cityCode = cityList[j].cityCode;
      //             }
      //         }
      //     }
      // }
    },

    //选中一个省份
    selectProvince: function selectProvince(item) {
      this.nowEditProvince.provinceCode = item.provinceCode;
      this.nowEditProvince.provinceName = item.provinceName;
      this.nowEditProvince.cityList = item.cityList;
      // this.selectCity(item.cityList[0]);

      this.$nextTick(function () {
        $("#cityBox").scrollTop(0);
      });
    },
    //选中城市
    selectCity: function selectCity(city, type) {
      // console.log(city, "<---selectCity");

      this.nowEditCity.provinceName = this.nowEditProvince.provinceName;
      this.nowEditCity.provinceCode = this.nowEditProvince.provinceCode;
      this.nowEditCity.cityName = city.cityName;
      this.nowEditCity.cityCode = city.cityCode;
      this.setNowDistrict();
      this.nowEditCity.districtName = "";
      this.nowEditCity.districtCode = "";
      this.confirmCity();
      this.fetchTJInfo(city, type);
    },
    //选中区
    selectDistrict: function selectDistrict(district) {
      if (district) {
        this.nowEditCity.districtName = district.districtName;
        this.nowEditCity.districtCode = district.districtCode;
      } else {
        this.nowEditCity.districtName = "";
        this.nowEditCity.districtCode = "";
      }
      this.confirmCity();
    },
    cityBoxScroll: function cityBoxScroll() {
      if ($("#cityBox").scrollTop() <= 0) {
        $("#cityBox").scrollTop(1);
      }
    },
    //重置
    resetCity: function resetCity() {
      var that = this;
      if (that.localCity.cityName && that.localCity.provinceName) {
        that.nowEditProvince.provinceName = that.localCity.provinceName;
        that.nowEditCity.cityName = that.localCity.cityName;
      } else {
        that.setDefaultCity(that.nowEditProvince, that.user);
        that.setDefaultCity(that.nowEditCity, that.user);
      }
      for (var i = that.provinceList.length - 1; i >= 0; i--) {
        if (that.provinceList[i].provinceCode == 100 || that.provinceList[i].provinceName.indexOf(that.nowEditProvince.provinceName) >= 0) {
          var cityList = that.provinceList[i].cityList;
          that.selectProvince(that.provinceList[i]);
          for (var j = 0; j < cityList.length; j++) {
            if (that.theSameCity(cityList[j].cityName, that.nowEditCity.cityName)) {
              that.selectCity(cityList[j]);
            }
          }
        }
      }
      that.confirmCity();
    },
    //确认地址
    confirmCity: function confirmCity() {
      var that = this;
      if (!that.nowEditCity.cityCode) {
        toast("请选择省市");
      } else {
        that.currentProvince = JSON.parse(JSON.stringify(that.nowEditProvince));
        that.currentCity = JSON.parse(JSON.stringify(that.nowEditCity));
        that.showCityDialog();
        that.submitData(2);
        that.removeCityNameParameter();
      }
    },
    //提交数据
    submitData: function submitData(type) {
      var currentCity = {
        provinceCode: this.findProvinceByCity(this.currentCity.cityName).provinceCode,
        provinceName: this.findProvinceByCity(this.currentCity.cityName).provinceName || this.currentCity.provinceName,
        cityName: this.currentCity.cityName,
        cityCode: this.currentCity.cityCode,
        districtName: this.currentCity.districtName,
        districtCode: this.currentCity.districtCode
      };
      var returnData = {
        type: type,
        gpsCity: JSON.parse(JSON.stringify(this.localCity)),
        currentCity: JSON.parse(JSON.stringify(currentCity))
      };
      // window.localStorage.setItem(this.localStorageName, JSON.stringify(currentCity));
      this.setPositionToLocalStorage(currentCity);
      this.isShowHomePage();
      //修改选中省份历史记录
      if (type !== 1) {
        this.setHistoryCity();
      }
      this.$emit("submitcity", returnData);
    },
    isShowHomePage: function isShowHomePage() {
      databus({
        url: "/apiv2/layout/greyRelease",
        data: {
          city: this.currentCity.cityName
        },
        success: function success(data) {
          if (data.code == 1000 && data.bcode == 100) {
            var homePage = data.content.setNewLayout;
            window.localStorage.setItem("homePage", homePage);
          }
        },
        error: function error() {}
      });
    },
    findProvinceByCity: function findProvinceByCity(cityName) {
      var that = this;
      var item = {
        provinceCode: "",
        provinceName: ""
      };
      for (var i = 0; i < that.provinceList.length; i++) {
        if (that.provinceList[i].provinceCode != 100) {
          var cityList = that.provinceList[i].cityList;
          for (var j = 0; j < cityList.length; j++) {
            if (that.theSameCity(cityList[j].cityName, cityName)) {
              item = that.provinceList[i];
              break;
            }
          }
        }
      }
      return item;
    },
    findDistrictListByCity: function findDistrictListByCity(cityName) {
      var that = this;
      var list = [];
      for (var i = 0; i < that.provinceList.length; i++) {
        if (that.provinceList[i].provinceCode != 100) {
          var cityList = that.provinceList[i].cityList;
          for (var j = 0; j < cityList.length; j++) {
            if (cityList[j].cityName == cityName) {
              list = cityList[j].districtList || [];
              break;
            }
          }
        }
      }
      return list;
    },
    //修改选中历史数据
    setHistoryCity: function setHistoryCity() {
      var that = this;
      if (!that.theSameCity(that.currentCity.cityName, that.provinceList[0].cityList[0].cityName)) {
        var historyList = JSON.parse(window.localStorage.getItem(that.localStorageName + "_history")) || [];
        var currentCity = {
          provinceName: that.currentCity.provinceName,
          cityName: that.currentCity.cityName,
          cityCode: that.currentCity.cityCode,
          provinceCode: that.currentCity.provinceCode
        };
        //去重
        for (var i = 0; i < historyList.length; i++) {
          if (that.theSameCity(historyList[i].cityName, that.currentCity.cityName) || historyList[i].cityCode == that.currentCity.cityCode) {
            historyList.splice(i, 1);
            break;
          }
        }
        historyList.unshift(currentCity);
        window.localStorage.setItem(that.localStorageName + "_history", JSON.stringify(historyList.slice(0, 6)));
        that.extendCityList();
      }
    },
    //显示区县
    setDistrictShow: function setDistrictShow() {
      this.districtBox.show ? this.hideDistrict() : this.showDistrict();
    },
    showDistrict: function showDistrict() {
      this.districtBox.show = true;
      this.$nextTick(function () {
        this.districtBox.height = $("#componentCityDistrictList").height();
      });
    },
    hideDistrict: function hideDistrict() {
      this.districtBox.show = false;
    },
    theSameProvince: function theSameProvince(oneProvince, twoProvince) {
      oneProvince = String(oneProvince || "");
      twoProvince = String(twoProvince || "");
      return oneProvince && twoProvince && oneProvince.replace(/(省*$)/g, "") == twoProvince.replace(/(省*$)/g, "");
    },
    theSameCity: function theSameCity(oneCity, twoCity) {
      oneCity = String(oneCity || "");
      twoCity = String(twoCity || "");
      return oneCity && twoCity && oneCity.replace(/(市*$)/g, "") == twoCity.replace(/(市*$)/g, "");
    },
    theSameDistrict: function theSameDistrict(oneDistrict, twoDistrict) {
      oneDistrict = String(oneDistrict || "");
      twoDistrict = String(twoDistrict || "");
      return oneDistrict && twoDistrict && oneDistrict.replace(/(区|县|街道*$)/g, "") == twoDistrict.replace(/(区|县|街道*$)/g, "");
    },
    _showCity: function _showCity(value) {
      var filterNumber = this.filterCityNumber;
      filterNumber = filterNumber ? filterNumber : filterNumber == 0 ? 99 : 4;
      value = value.replace("市", "");
      if (value.length > filterNumber) {
        value = value.substring(0, filterNumber) + "...";
      }
      return value;
    },
    _showDistrict: function _showDistrict(value) {
      var filterNumber = this.filterDistrictNumber;
      filterNumber = filterNumber ? filterNumber : filterNumber == 0 ? 99 : 5;
      if (value.length > filterNumber) {
        value = value.substring(0, filterNumber) + "...";
      }
      return value ? value : "全城";
    }
  }
};